import { useAuth0 } from '@auth0/auth0-react'

import { userClaimIds } from '../utils/userClaims'
import useSiteMetadata from './useSiteMetadata'

type UseLabelNameResult =
  | {
      _tag: 'Failure'
      error: string
    }
  | {
      _tag: 'NotApplicable'
    }
  | {
      _tag: 'Success'
      labelName: string
    }

export function useLabelName(): UseLabelNameResult {
  const { featureFlags } = useSiteMetadata() ?? {}
  const { user } = useAuth0()
  const labelName = user ? user[userClaimIds.companyName] : undefined

  if (!featureFlags?.productLabelStatus) {
    return {
      _tag: 'NotApplicable',
    }
  }

  return labelName
    ? {
        _tag: 'Success',
        labelName,
      }
    : {
        _tag: 'Failure',
        error: 'No company name found for user.',
      }
}
